import { toOtpLoginViewModel } from '@apis/responseTransformer';
import { ResponseCode, OtpLoginRequest, OtpType, CaptchaInfo, OtpInfo } from '@ul/api';

function sendResponse(responseCode: ResponseCode) {
    const captchaInfo: CaptchaInfo = {
        captchaType: 'recaptcha',
        apiKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    };
    const otpInfo: OtpInfo = {
        otpType: OtpType.Phone,
        token: 'mock-otp-token',
        target: 'mock-otp-target',
    };

    let success = false;
    let message = 'error';
    let fillCaptchaInfo = false;
    let fillOtpInfo = false;

    switch (responseCode) {
        case ResponseCode.NeedCaptcha:
            message = 'need captcha';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.NeedOtp:
            message = 'need otp';
            fillOtpInfo = true;
            break;
        case ResponseCode.CaptchaVerificationFailed:
            message = 'captcha failed';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.OtpVerificationFailed:
            message = 'otp failed';
            fillOtpInfo = true;
            break;
        case ResponseCode.ErrorOccurred:
            message = 'internal error';
            break;
        case ResponseCode.UserLocked:
            message = 'user locked';
            break;
        case ResponseCode.DidNotMeetCriteria:
            message = "request doesn't meet criteria";
            break;
        default:
            success = true;
            message = 'successfully login';
            break;
    }

    return Promise.resolve(
        toOtpLoginViewModel({
            success,
            message,
            responseCode,
            captchaInfo: fillCaptchaInfo ? captchaInfo : undefined,
            otpInfo: fillOtpInfo ? otpInfo : undefined,
        })
    );
}

export const otpLoginMock = (request: OtpLoginRequest) => {
    const username = request.username;
    switch (username) {
        case '+66100012345':
            if (!!request.otpVerifyInfo) {
                return sendResponse(ResponseCode.Successful);
            }
            if (!!request.captchaVerifyInfo) {
                return sendResponse(ResponseCode.NeedOtp);
            }
            return sendResponse(ResponseCode.NeedCaptcha);
        case '+66200012345':
            if (!!request.otpVerifyInfo) {
                return sendResponse(ResponseCode.OtpVerificationFailed);
            }
            if (!!request.captchaVerifyInfo) {
                return sendResponse(ResponseCode.NeedOtp);
            }
            return sendResponse(ResponseCode.NeedCaptcha);
        case '+66300012345':
            if (!!request.captchaVerifyInfo) {
                return sendResponse(ResponseCode.CaptchaVerificationFailed);
            }
            return sendResponse(ResponseCode.NeedCaptcha);
        case '+66400012345':
            return sendResponse(ResponseCode.ErrorOccurred);
        case '+66500012345':
            return sendResponse(ResponseCode.UserLocked);
        default:
            return sendResponse(ResponseCode.Successful);
    }
};
